import React, { useEffect, useState } from 'react';
import handleChange from '../../../../../utils/handleChange';
import Dropdown, { Dropdown1 } from '../../../../../components/dropdown/Dropdown';
// import { getFormattedDateReverse } from '../../../../../utils/date';
import Tooltip from '../../../../../components/tooltip/Tooltip';
import { ReactComponent as InfoI } from '../../../../../assets/icons/trvto_info.svg';

export const BackPackingFixedTripBookingTab = ({
    booking,
    confirmedBookingData,
    numPeople,
    numOfRooms,
    setBooking,
    startDates,
    isDateSelected,
    handleSelectedDate,
    selectedDate,
    handleBaseCity,
    startCity,
    optionsForPickup,
    packData,
    transport,
    setIndex,
    packDates
}) => {
    const [isRoomChecked, setIsRoomChecked] = useState(false);
    const [totalAvailiableRooms, setTotalAvailiableRooms] = useState();

    const handleRoomCheckbox = (event) => {
        const checked = event.target.checked;
        setIsRoomChecked(checked);
        if (!checked) {
            setBooking((prev) => ({
                ...prev,
                room: 0
            }));
        }
    };

    useEffect(() => {
        setTotalAvailiableRooms(packDates?.reduce((acc, item) => acc + item.totalRooms, 0));
        setIsRoomChecked(booking.room > 0 ? true : false);
        //eslint-disable-next-line
    }, [packDates]);

    return (
        <div className=''>
            <>
                <div className='dropdownDiv'>
                    <label className='tripBookDatalabelFirst'>No. of People</label>
                    <select
                        value={booking.people}
                        name='people'
                        onChange={(e) => handleChange(e, setBooking)}
                        required={true}
                        className='dropdownSelect'
                        disabled={confirmedBookingData?.userDetails.length}
                    >
                        {numPeople.map(function (val, typeIndex) {
                            return (
                                <option key={typeIndex} value={val}>
                                    {val}
                                </option>
                            );
                        })}
                    </select>
                </div>
                <div className='dropdownDiv bookingDate'>
                    {/* <label className='tripBookDatalabel2'>Select Date</label>
                        <SingleDatePicker
                            date={booking.date}
                            onDateChange={(date) => {
                                setBooking((prevState) => {
                                    return { ...prevState, date: date };
                                });
                                handleSelectedDate(date);
                            }}
                            focused={focused}
                            onFocusChange={({ focused }) => setFocused(focused)}
                            numberOfMonths={1}
                            displayFormat='DD-MM-YYYY'
                            isDayBlocked={isDayBlocked}
                            isOutsideRange={(day) => day.isBefore(moment(), 'day')}
                        /> */}
                    <Dropdown1
                        label='Select Date'
                        name='date'
                        options={startDates}
                        value={booking.date}
                        req={true}
                        setFormData={setBooking}
                        handleSelectedDate={handleSelectedDate}
                        disabled={confirmedBookingData?.startDate && confirmedBookingData?.isTripMoreThanOneDays}
                    />
                    {/* {isDateSelected ? (
                        <p className='slotsLeft'>
                            Slots left{' '}
                            {selectedDate?.totalSlots - selectedDate?.bookedSlots > 15
                                ? 15
                                : selectedDate?.totalSlots - selectedDate?.bookedSlots}{' '}
                            & Booking ends on {getFormattedDateReverse(selectedDate?.bookingEnd)}
                        </p>
                    ) : (
                        <></>
                    )} */}
                </div>
                {/* {packData.withoutTransportPrice !== 0 && (
                    <Dropdown
                        label='Transport'
                        name='transport'
                        options={transport}
                        value={booking.transport}
                        req={true}
                        setFormData={setBooking}
                        // disabled={!confirmedBookingData?.isTripMoreThanOneDays}
                    />
                )} */}
                {booking.transport === 'With transport' && (
                    <>
                        <div className='dropdownDiv'>
                            <div className='dropdownLabelText'>
                                <label className='dropdownlabel'>Start City</label>
                                <Tooltip content='Select the city from where your trip starts' position='top'>
                                    <span className='eyeIcon'>
                                        <InfoI color='blue' width={15} height={15} />
                                    </span>
                                </Tooltip>
                            </div>
                            <select
                                value={booking.startCity}
                                name='startCity'
                                onChange={(e) => handleBaseCity(e, setBooking, startCity.current, setIndex)}
                                required={true}
                                className='dropdownSelect'
                                disabled={confirmedBookingData?.startCity}
                            >
                                <option value='-1'>Select</option>
                                {startCity.current.map(function (val, typeIndex) {
                                    return (
                                        <option key={typeIndex} value={val}>
                                            {val}
                                        </option>
                                    );
                                })}
                            </select>
                        </div>
                        <Dropdown
                            label='Pickup Location'
                            name='pickupLocation'
                            options={optionsForPickup}
                            value={booking?.pickupLocation || booking?.meetupPoint}
                            req={true}
                            setFormData={setBooking}
                            disabled={
                                (!confirmedBookingData?.isTripMoreThanOneDays &&
                                    confirmedBookingData?.pickupLocation) ||
                                !booking?.startCity
                            }
                            infoIcon={true}
                            infoContent={'Select Pickup location from the options'}
                        />
                    </>
                )}
                {totalAvailiableRooms > 0 &&
                (packData?.room || packData?.price[0]?.price?.room) &&
                (packData?.room || packData?.price[0]?.price?.room > 0) ? (
                    <>
                        <div id='checkbox-div'>
                            <input
                                type='checkbox'
                                id='roomCheck'
                                checked={isRoomChecked}
                                onChange={handleRoomCheckbox}
                                disabled={confirmedBookingData?.startCity}
                            />
                            <label
                                htmlFor='roomCheck'
                                id='tripReserveLabel'
                                style={{
                                    fontFamily: 'inherit',
                                    fontSize: '16px',
                                    paddingLeft: '26px',
                                    lineHeight: '16px',
                                    paddingTop: '6px'
                                }}
                            >
                                Are you looking for personal room at extra price
                            </label>
                        </div>
                        {isRoomChecked && (
                            <div className='dropdownDiv dropdown-room-div'>
                                <div>
                                    <label className='tripBookDatalabelFirst'>No. of Rooms</label>
                                    <span style={{ marginLeft: 5 }}>
                                        <Tooltip
                                            content='Select the number of rooms you want to book (optional)'
                                            position='top'
                                        >
                                            <span className='eyeIcon'>
                                                <InfoI color='blue' width={15} height={15} />
                                            </span>
                                        </Tooltip>
                                    </span>
                                </div>
                                <select
                                    value={booking.room || ''}
                                    name='room'
                                    onChange={(e) =>
                                        setBooking((prev) => ({
                                            ...prev,
                                            room: Number(e.target.value)
                                        }))
                                    }
                                    required={true}
                                    className='dropdownSelect'
                                >
                                    <option value={''}>Select</option>
                                    {numOfRooms
                                        .filter((itemVal) => itemVal <= totalAvailiableRooms)
                                        .map(function (val, typeIndex) {
                                            return (
                                                <option key={typeIndex} value={val}>
                                                    {val}
                                                </option>
                                            );
                                        })}
                                </select>
                            </div>
                        )}
                    </>
                ) : null}
            </>
        </div>
    );
};
